type ExperienceDebugWindow = Window & {
  experience?: {
    debug?: {
      active?: boolean;
    };
  };
};

export function debugLog(...args: unknown[]) {
  const debugWindow = window as ExperienceDebugWindow;
  if (debugWindow.experience?.debug?.active) {
    console.log(...args);
  }
}
